// extracted by mini-css-extract-plugin
export var TitleContent = "styles-module--TitleContent--I4Sat";